import cs from 'classnames';
import type { ReactNode } from 'react';
import { useMemo } from 'react';
import { Tooltip } from 'antd';

import Icon from '../../icon';

import css from './styles.module.scss';

interface IFieldsContainerProps {
  children: ReactNode;
  label?: string | ReactNode;
  error?: string | null;
  requiredTag?: boolean;
  hideLabel?: boolean;
}

function FieldsContainer({
  children,
  label,
  error,
  requiredTag,
  hideLabel,
}: IFieldsContainerProps) {
  const classnames = useMemo(
    () => ({
      label: cs(css.label, {
        [css.labelError]: error,
      }),
    }),
    [error],
  );

  return (
    <>
      {hideLabel ?
        children
      : <div className={css.container}>
          <div className={css.title}>
            {!!error && (
              <div className={css.error}>
                <Tooltip
                  title={<div className={css.errorTitle}>{error}</div>}
                  placement="top"
                  color="#facdd4"
                >
                  <span className={css.errorIcon}>
                    <Icon name="legacy/question" />
                  </span>
                </Tooltip>
              </div>
            )}
            <span className={classnames.label}>
              <span className={error ? css.labelError : ''}>
                {label ?? <span className={css.hiddenText}>_</span>}
              </span>
              {requiredTag && <span className={css.required}>*</span>}
            </span>
          </div>
          {children}
        </div>
      }
    </>
  );
}

export default FieldsContainer;
